import { render, staticRenderFns } from "./BattlesBetElement.vue?vue&type=template&id=ae89c39c&scoped=true"
import script from "./BattlesBetElement.vue?vue&type=script&lang=js"
export * from "./BattlesBetElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesBetElement.vue?vue&type=style&index=0&id=ae89c39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae89c39c",
  null
  
)

export default component.exports